module.exports = __webpack_public_path__ + "static/media/IN_Payslip_6.677e4c42.png";